// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import { Avatar, Divider } from "@mui/material";
import MDAvatar from "components/MDAvatar";
import DetailList from "components/DetailList";
import { useEffect, useState } from "react";
import { areAllValuesEmpty } from "components/helper";

const Review = ({ formData, editPage = false, selectedPrimaryDestination = {} }) => {
  const { values } = formData;
  const [venueInfoData, setVenueInfoData] = useState({});
  const [addressInfoData, setAddressInfoData] = useState({});
  const [fields, setFields] = useState([]);
  useEffect(() => {
    if (values) {
      setVenueInfoData({
        title: values?.title,
        fomoMessage: values?.fomoMessage,
        top: values?.top,
        primaryDestination:
          values?.primaryDestinationId?.destinationName || selectedPrimaryDestination?.label,
      });
      setAddressInfoData({
        address: values?.address,
        country: values?.country,
        city: values?.city,
        lat: values?.lat,
        lng: values?.lng,
      });
    }
  }, [values]);

  useEffect(() => {
    setFields([
      { id: 0, title: "Information", data: venueInfoData },
      { id: 1, title: "Address", data: addressInfoData },
    ]);
  }, [venueInfoData, addressInfoData]);

  const BigAvatar = styled(Avatar)`
    width: 74px;
    height: 74px;
  `;

  return (
    <MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          {!editPage ? (
            <Grid size={{ xs: 12, sm: 6 }}>
              {values?.thumbnailHiResURL ? (
                <MDAvatar
                  src={URL.createObjectURL(values?.thumbnailHiResURL)}
                  alt="profile-image"
                  size="xl"
                  sx={{ "& img": { height: "100%" } }}
                />
              ) : (
                <BigAvatar
                  alt="Change your profile photo"
                  src={URL.revokeObjectURL(values?.thumbnailHiResURL)}
                  imgProps={{
                    style: {
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "cover",
                    },
                  }}
                />
              )}
            </Grid>
          ) : (
            ""
          )}
          {fields?.map((field, i) => (
            <Grid
              item
              key={field.id}
              size={{ xs: 12 }}
              sx={{
                display: areAllValuesEmpty(field.data) ? "none" : "flex",
                flexDirection: "column",
              }}
            >
              <DetailList data={field.data} title={field?.title} />
              {i + 1 !== fields?.length && (
                <div>
                  <Divider sx={{ height: "1px" }} />
                </div>
              )}{" "}
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </MDBox>
  );
};

// typechecking props for Review
Review.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.func]).isRequired,
  editPage: PropTypes.bool,
  selectedPrimaryDestination: PropTypes.instanceOf(Object),
};

export default Review;
